import { render, staticRenderFns } from "./FundBasic.vue?vue&type=template&id=c558ebf0"
import script from "./FundBasic.vue?vue&type=script&lang=js"
export * from "./FundBasic.vue?vue&type=script&lang=js"
import style0 from "./FundBasic.vue?vue&type=style&index=0&id=c558ebf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports